import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

function LoadingAdmin() {
  const sidebarToggle = useSelector((state) => state.shopsyReducer.toggleSidebar)

  const [sidebar,setSidebar] = useState(Boolean)
  useEffect(()=>{
    setSidebar(!sidebarToggle.sidebar)
  },[sidebarToggle])

  let circleCommonClasses = 'h-16 w-4 bg-current text-slate-800 rounded-full'; 
  return (
    <div className='fixed insest-0 z-50'>
    <div className={` flex ${sidebar?  "w-[90vw]" : "w-[65vw]"}  justify-center items-center h-[70vh]`}>

      <div className='flex'>
        <div className={`${circleCommonClasses} mr-1.5 animate-bounce`}></div>
        <div className={`${circleCommonClasses} mr-1.5 animate-bounce200`}></div>
        <div className={`${circleCommonClasses} mr-1.5 animate-bounce300`}></div>
        <div className={`${circleCommonClasses} animate-bounce400`}></div>
      </div>
      
      </div>
    </div>
  )
}

export default LoadingAdmin